import classNames from 'classnames';
import { capitalize, lowerCase } from 'lodash';
import { useMemo, useState } from 'react';
import { EditEntityCommunicationSettingsTab } from '@/modules/investor-dashboard/components/EditEntityCommunicationSettingsTab.tsx';
import { EditEntityPaymentTab } from '@/modules/investor-dashboard/components/EditEntityPaymentTab.tsx';
import { BaseModalProps, ModalContentWrapper, Tabs } from 'ui';
import { EntityWithDocumentResponse } from 'api';

export enum EditEntityTabItem {
  CommunicationSettings = 'Communication settings',
  PaymentInstructions = 'payment_info',
}

interface EditEntityModalProps extends BaseModalProps {
  entity: EntityWithDocumentResponse;
  defaultTab?: EditEntityTabItem;
  onSuccess?: () => void;
}

const EditEntityModal = ({
  open,
  entity,
  onClose,
  defaultTab = EditEntityTabItem.CommunicationSettings,
  onSuccess,
}: EditEntityModalProps) => {
  const [activeTab, setActiveTab] = useState<EditEntityTabItem>(defaultTab);

  const tabItems = useMemo(
    () => [
      {
        name: EditEntityTabItem.CommunicationSettings,
        container: <EditEntityCommunicationSettingsTab entityId={entity.id} />,
      },
      {
        name: EditEntityTabItem.PaymentInstructions,
        container: <EditEntityPaymentTab entity={entity} onSuccess={onSuccess} />,
      },
    ],
    [entity, onSuccess],
  );

  return (
    <ModalContentWrapper title={`${entity.entity_name} settings`} open={open} onClose={onClose}>
      <div>
        <div className="w-full flex items-center justify-start space-x-6 relative border-b border-gray-200 pb-[12px]">
          {tabItems.map(({ name }) => (
            <button
              key={name}
              className={classNames('text-[14px] leading-[22px] font-medium relative', {
                'text-gray-500': activeTab !== name,
                'rounded-underline': activeTab === name,
              })}
              onClick={() => setActiveTab(name)}
            >
              {capitalize(lowerCase(name))}
            </button>
          ))}
        </div>
        <Tabs activeTab={activeTab} items={tabItems} />
      </div>
    </ModalContentWrapper>
  );
};

export default EditEntityModal;
